import React, { Component } from 'react';
import Dropdown from '../components/dropdown';
import PropTypes from 'prop-types';
import equals from 'equals'

export default class DropdownBtn extends Component {
    static propTypes = {
        btnClassName: PropTypes.string,
        items: PropTypes.array,
        xAlign: PropTypes.string,
        defaultXPosition: PropTypes.string,
        onDropdownShow: PropTypes.func,
        onDropdownHide: PropTypes.func,
        onItemClick: PropTypes.func,
        children: PropTypes.any
    };

    static defaultProps = {
        className: '',
        items: []
    };

    constructor(props) {
        super(props);

        this.state = {
            dropdownVisible: false
        };

        this.dropdownCtrl = null;
    }

    handleBtnClick = () => {
        this.showDropdown();
    }

    handleDropdownShow = () => {
        this.setState({
            dropdownVisible: true
        });

        this.props.onDropdownShow && this.props.onDropdownShow();
    }

    handleDropdownHide = () => {
        this.setState({
            dropdownVisible: false
        });

        this.props.onDropdownHide && this.props.onDropdownHide();
    }

    showDropdown() {
        if (this.state.dropdownVisible) {
            return;
        }

        this.dropdownCtrl.show();

        const documentClickHandler = () => {
            this.hideDropdown();

            document.removeEventListener('click', documentClickHandler);
        };

        setTimeout(() => {
            document.addEventListener('click', documentClickHandler);
        }, 0);
    }

    hideDropdown() {
        if (!this.state.dropdownVisible) {
            return;
        }

        if (this.dropdownCtrl) {
            this.dropdownCtrl.hide();   
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.btnClassName !== nextProps.btnClassName) return true;
        if (this.props.dropdownClassName !== nextProps.dropdownClassName) return true;
        if (this.props.xAlign !== nextProps.xAlign) return true;
        if (this.props.defaultXPosition !== nextProps.defaultXPosition) return true;
        if (!equals(this.props.items, nextProps.items)) return true;
        if (!equals(this.props.children, nextProps.children)) return true;
        if (!equals(this.state, nextState)) return true;

        return false;
    }

    render() {
        return (
            <div className={'dropdown-btn ' + this.props.className}>
                <div className={('dropdown-btn-element ' + this.props.btnClassName + (this.state.dropdownVisible ? ' selected' : ''))} onClick={this.handleBtnClick}>
                    {this.props.children}
                </div>

                <Dropdown
                    className={this.props.dropdownClassName}
                    keepVisible={this.props.keepVisible}
                    title={this.props.title}
                    items={this.props.items}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    itemComponent={this.props.itemComponent}
                    showArrow={this.props.showArrow}
                    provideController={ctrl => this.dropdownCtrl = ctrl}
                    onShow={this.handleDropdownShow}
                    onHide={this.handleDropdownHide}
                    onItemClick={this.props.onItemClick && this.props.onItemClick}
                />
            </div>
        );
    }
}
